import Client from './KomodoClient';
import { pagerRows } from './Resource';

// komodo MenuController (api/menu): the menu layer above menu groups. One menu is applied to one or
// many stores (komodo companies); a store refers to exactly one menu. See
// simple_config/docs/specs/psi-menu-index.md.
const enc = encodeURIComponent;

export const MENU_TYPE = { UNIVERSAL: 0, STANDALONE: 1 };

// false until the merchant ran `migrate`: until then menu groups still follow gy_menu_group.DeptCode.
const enabled = () => Client.get('/api/menu/enabled');
const list = () => Client.get('/api/menu').then(pagerRows);
// One row per store: which menu it refers to (menuCode empty = not set).
const depts = () => Client.get('/api/menu/depts').then(pagerRows);
const get = (code) => Client.get(`/api/menu/${enc(code)}`);
const create = (dto) => Client.post('/api/menu', dto);
const update = (code, dto) => Client.put(`/api/menu/${enc(code)}`, dto);
// Soft delete; fails while a store still refers to the menu.
const remove = (code) => Client.del(`/api/menu/${enc(code)}`);
// Stores this menu is applied to. Unticked stores fall back to a standalone copy of it.
const setDepts = (code, deptCodes) =>
	Client.put(`/api/menu/${enc(code)}/depts`, deptCodes);
// Point a store at another menu; menuCode null = give it a standalone menu based on the current one.
const setDeptMenu = (deptCode, menuCode) =>
	Client.put(`/api/menu/dept/${enc(deptCode)}`, { menuCode: menuCode || null });
// Groups of a menu in menu order, each with `sharedWith` (other menus containing it).
const groups = (code) =>
	Client.get(`/api/menu/${enc(code)}/groups`).then(pagerRows);
// Create a menu group inside the menu (appended last); returns the MenuGroupInMenuDTO row.
const createGroup = (code, dto) =>
	Client.post(`/api/menu/${enc(code)}/groups`, dto);
// Whole-list overwrite: groups missing from the list are removed from the menu (soft).
const saveGroups = (code, rows) =>
	Client.put(`/api/menu/${enc(code)}/groups`, rows);
const copy = (code, dto) => Client.post(`/api/menu/${enc(code)}/copy`, dto);
// Make the product available to every store that refers to the menu (gy_material_deptinfo).
const assignProduct = (code, materialCode) =>
	Client.post(`/api/menu/${enc(code)}/assign-product/${enc(materialCode)}`);
// One-off, idempotent: merchant-wide groups → default menu; stores with private groups → standalone.
const migrate = () => Client.post('/api/menu/migrate');

export default {
	enabled,
	list,
	depts,
	get,
	create,
	update,
	remove,
	setDepts,
	setDeptMenu,
	groups,
	createGroup,
	saveGroups,
	copy,
	assignProduct,
	migrate,
};
